import filledGreenOvalSrc from "../../assets/images/filled-green-oval.png";
import regularGreenOvalSrc from "../../assets/images/regular-green-oval.png";
import styled from "styled-components";

export const Paragraph = styled.p`
  width: 100%;
  font-size: 16px;
  color: ${props => props.theme.COLORS.GREEN.lightGreen};
`;

export const Title = styled.p`
  width: 100%;
  color: ${props => props.theme.COLORS.GREEN.lightGreen};
  font-size: 26px;
  margin-top: 2rem;
`;

export const SlideContainer = styled.div`
  width:100%;
  height: auto;
`;

export const BackgroundImageContainer = styled.div`
  position: relative;
`;

export const RegularGreenOval = styled.img.attrs({ src: regularGreenOvalSrc })`
position: absolute;
height: 84px;
width: 78px;
top: -6px;
left: 327px;
@media (max-width: 468px) {
  width: 52px;
  height: 59px;
  top: -19px;
  left: 217px;
}
`;
